import * as tslib_1 from "tslib";
import { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import * as moment from 'moment';
import { LoaderService } from 'src/app/loader.service';
import { AlertDialogService } from 'src/app/shared/alert-dialog/alert-dialog.service';
import { Toaster, ToasterType } from 'src/app/shared/types/toaster.types';
import { ToasterService } from 'src/app/toaster.service';
import { SharedService } from 'src/app/shared/shared.service';
import { SubscriptionService } from '../../subscription.service';
import { ruleTypeLabel as labelForRuleType } from '../../subscription.applicable-types';
import { environment } from 'src/environments/environment';
import { subscriptionCreateSuccessAlert, subscriptionOperationFailureAlert } from '../../subscription.create-alert';
var CreatePostpaidComponent = /** @class */ (function () {
    function CreatePostpaidComponent(subsService, sharedService, loader, alertService, toasterService) {
        this.subsService = subsService;
        this.sharedService = sharedService;
        this.loader = loader;
        this.alertService = alertService;
        this.toasterService = toasterService;
        this.context = null;
        this.postpaidFormGroup = new FormGroup({
            ruleName: new FormControl(null),
            ruleTitle: new FormControl(null),
            startDate: new FormControl(null),
            endDate: new FormControl(null),
            excludedServices: new FormControl([]),
            targetSegment: new FormControl('entireCity'),
            priority: new FormControl(0),
            userSelector: new FormControl(null),
            ruleType: new FormControl('zeroCommission'),
            rules: new FormArray([])
        });
        this.validityTypes = ['earnings', 'rides', 'unlimited'];
        this.cashbackTypes = ['none', 'rides'];
        this.eligibleRuleTypes = ['zeroCommission'];
        this.userSelectors = [];
        this.today = moment().startOf('hour').toDate();
        this.maxRulesAtOnce = environment.maxRulesCreationAtOnce;
    }
    Object.defineProperty(CreatePostpaidComponent.prototype, "subscriptionTitles", {
        get: function () {
            var titles = this.context && this.context.displayTitles;
            return Array.isArray(titles) ? titles : [];
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePostpaidComponent.prototype, "taxInfoText", {
        get: function () {
            return this.context && this.context.exclusiveOfTax
                ? 'This amount is exclusive of tax'
                : 'This amount is inclusive of tax';
        },
        enumerable: true,
        configurable: true
    });
    CreatePostpaidComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.addRule();
        this.postpaidFormGroup.get('targetSegment').valueChanges.subscribe(function () {
            _this.applyTargetSegment();
            _this.syncValidityForTargetSegment();
        });
        this.applyTargetSegment();
        this.syncValidityForTargetSegment();
        this.applyEligibleRuleTypes();
    };
    CreatePostpaidComponent.prototype.ngOnChanges = function (changes) {
        if (changes['context']) {
            this.applyEligibleRuleTypes();
            var previous = changes['context'].previousValue;
            var current = changes['context'].currentValue;
            if (this.showUserSelector && this.selectorContextKey(previous) !== this.selectorContextKey(current)) {
                this.postpaidFormGroup.get('userSelector').setValue(null, { emitEvent: false });
                this.fetchSelectors();
            }
        }
    };
    CreatePostpaidComponent.prototype.selectorContextKey = function (context) {
        if (!context || !context.city) {
            return '';
        }
        return context.city.id + ':' + (context.categoryServices || []).map(function (service) { return service.serviceDetailId; }).join(',');
    };
    CreatePostpaidComponent.prototype.ruleTypeLabel = function (type) {
        return labelForRuleType(type);
    };
    Object.defineProperty(CreatePostpaidComponent.prototype, "isRuleTypeLocked", {
        get: function () {
            return this.eligibleRuleTypes.length === 1;
        },
        enumerable: true,
        configurable: true
    });
    CreatePostpaidComponent.prototype.applyEligibleRuleTypes = function () {
        var types = (this.context && this.context.eligibleRuleTypes) || [];
        this.eligibleRuleTypes = types.length ? types : ['zeroCommission'];
        var current = this.postpaidFormGroup.get('ruleType').value;
        if (this.eligibleRuleTypes.indexOf(current) === -1) {
            this.postpaidFormGroup.get('ruleType').setValue(this.eligibleRuleTypes[0], { emitEvent: false });
        }
        if (this.eligibleRuleTypes.length === 1) {
            this.postpaidFormGroup.get('ruleType').disable({ emitEvent: false });
        }
        else {
            this.postpaidFormGroup.get('ruleType').enable({ emitEvent: false });
        }
    };
    Object.defineProperty(CreatePostpaidComponent.prototype, "isFemaleGender", {
        get: function () {
            return this.formValue('targetSegment') === 'femaleGender';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePostpaidComponent.prototype, "showUserSelector", {
        get: function () {
            return this.formValue('targetSegment') === 'userSelectors';
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CreatePostpaidComponent.prototype, "isCityWideSegment", {
        get: function () {
            var segment = this.formValue('targetSegment');
            return segment === 'entireCity' || segment === 'femaleGender';
        },
        enumerable: true,
        configurable: true
    });
    CreatePostpaidComponent.prototype.applyTargetSegment = function () {
        var segment = this.formValue('targetSegment') || 'entireCity';
        var priority = this.postpaidFormGroup.get('priority');
        var userSelector = this.postpaidFormGroup.get('userSelector');
        if (segment === 'userSelectors') {
            priority.enable({ emitEvent: false });
            userSelector.enable({ emitEvent: false });
            this.fetchSelectors();
            return;
        }
        priority.setValue(0, { emitEvent: false });
        priority.disable({ emitEvent: false });
        userSelector.setValue(null, { emitEvent: false });
        userSelector.disable({ emitEvent: false });
    };
    CreatePostpaidComponent.prototype.fetchSelectors = function () {
        var _this = this;
        if (!this.context || !this.context.city || !this.context.categoryServices || !this.context.categoryServices.length) {
            this.userSelectors = [];
            return;
        }
        var serviceTypes = this.context.categoryServices
            .map(function (service) { return service.serviceDetailId; })
            .join(',');
        this.loader.openLoading();
        this.sharedService
            .fetchRules(this.context.city.id, serviceTypes, null, 'rider')
            .toPromise()
            .then(function (res) {
            _this.userSelectors = (res.data.selectors || [])
                .map(function (_a) {
                var _id = _a._id, name = _a.name;
                return ({ id: _id, name: name });
            });
        })
            .finally(function () { return _this.loader.closeLoading(); });
    };
    Object.defineProperty(CreatePostpaidComponent.prototype, "rules", {
        get: function () {
            return this.postpaidFormGroup.get('rules');
        },
        enumerable: true,
        configurable: true
    });
    CreatePostpaidComponent.prototype.createRule = function () {
        var _this = this;
        var rule = new FormGroup({
            validityType: new FormControl('earnings'),
            maxValue: new FormControl(null),
            amount: new FormControl(null),
            periodInDays: new FormControl(null),
            cashbackType: new FormControl('none'),
            cashbackMinValue: new FormControl(null)
        });
        rule.get('amount').valueChanges.subscribe(function () { return _this.syncCashbackForAmount(rule); });
        rule.get('validityType').valueChanges.subscribe(function () { return _this.syncMaxValueForValidity(rule); });
        return rule;
    };
    Object.defineProperty(CreatePostpaidComponent.prototype, "canAddRule", {
        get: function () {
            return !this.isFemaleGender && this.rules.length < this.maxRulesAtOnce;
        },
        enumerable: true,
        configurable: true
    });
    CreatePostpaidComponent.prototype.addRule = function () {
        if (this.rules.length && !this.canAddRule) {
            return;
        }
        this.rules.push(this.createRule());
    };
    CreatePostpaidComponent.prototype.deleteRule = function (index) {
        this.rules.removeAt(index);
    };
    CreatePostpaidComponent.prototype.syncValidityForTargetSegment = function () {
        var _this = this;
        this.validityTypes = this.isFemaleGender ? ['unlimited'] : ['earnings', 'rides', 'unlimited'];
        if (this.isFemaleGender) {
            while (this.rules.length > 1) {
                this.rules.removeAt(this.rules.length - 1);
            }
            this.rules.controls.forEach(function (rule) { return rule.get('validityType').setValue('unlimited', { emitEvent: false }); });
        }
        this.rules.controls.forEach(function (rule) { return _this.syncMaxValueForValidity(rule); });
    };
    CreatePostpaidComponent.prototype.isPaidTargetValidity = function (rule) {
        var type = rule.get('validityType').value;
        return type === 'rides' || (type === 'unlimited' && !this.isFemaleGender);
    };
    CreatePostpaidComponent.prototype.isPaidUnlimited = function (rule) {
        return rule.get('validityType').value === 'unlimited' && !this.isFemaleGender;
    };
    CreatePostpaidComponent.prototype.syncMaxValueForValidity = function (rule) {
        var maxValue = rule.get('maxValue');
        var amount = rule.get('amount');
        var periodInDays = rule.get('periodInDays');
        if (this.isFemaleGender && rule.get('validityType').value === 'unlimited') {
            maxValue.setValue(null, { emitEvent: false });
            maxValue.disable({ emitEvent: false });
            amount.setValue(0);
            amount.disable({ emitEvent: false });
            periodInDays.setValue(null, { emitEvent: false });
            this.syncCashbackForAmount(rule);
            return;
        }
        if (this.isPaidUnlimited(rule)) {
            maxValue.setValue(null, { emitEvent: false });
            maxValue.disable({ emitEvent: false });
            amount.enable({ emitEvent: false });
            this.syncCashbackForAmount(rule);
            return;
        }
        maxValue.enable({ emitEvent: false });
        amount.enable({ emitEvent: false });
        periodInDays.setValue(null, { emitEvent: false });
        this.syncCashbackForAmount(rule);
    };
    CreatePostpaidComponent.prototype.maxValueLabel = function (rule) {
        var type = rule.get('validityType').value || 'earnings';
        if (type === 'rides') {
            return 'Ride target';
        }
        return 'Max ' + type.charAt(0).toUpperCase() + type.slice(1);
    };
    CreatePostpaidComponent.prototype.isZeroAmount = function (rule) {
        var amount = rule.get('amount').value;
        return amount !== null && amount !== '' && Number(amount) === 0;
    };
    CreatePostpaidComponent.prototype.syncCashbackForAmount = function (rule) {
        var cashback = rule.get('cashbackType');
        if (this.isZeroAmount(rule) || this.isPaidTargetValidity(rule)) {
            cashback.setValue('none', { emitEvent: false });
            rule.get('cashbackMinValue').setValue(null, { emitEvent: false });
            cashback.disable({ emitEvent: false });
            return;
        }
        cashback.enable({ emitEvent: false });
    };
    CreatePostpaidComponent.prototype.rejectNonPositiveAmount = function (event, control) {
        var input = event.target;
        if (input.value === '' || input.value == null) {
            return;
        }
        if (Number(input.value) <= 0) {
            control.setValue(null);
            input.value = '';
        }
    };
    CreatePostpaidComponent.prototype.formValue = function (name) {
        return this.postpaidFormGroup.get(name).value;
    };
    CreatePostpaidComponent.prototype.serviceLabel = function (item) {
        return item.name + (item.active ? '' : ' (inactive)');
    };
    Object.defineProperty(CreatePostpaidComponent.prototype, "includedCategoryServicesText", {
        get: function () {
            var _this = this;
            if (!this.context || !this.context.categoryServices) {
                return '';
            }
            var excludedIds = {};
            (this.formValue('excludedServices') || []).forEach(function (service) {
                excludedIds[service.id] = true;
            });
            return this.context.categoryServices
                .filter(function (service) { return !excludedIds[service.id]; })
                .map(function (service) { return _this.serviceLabel(service); })
                .join(', ');
        },
        enumerable: true,
        configurable: true
    });
    CreatePostpaidComponent.prototype.blockInvalidNumberKeys = function (event) {
        if (event.key === '-' || event.key === '+' || event.key === 'e' || event.key === 'E') {
            event.preventDefault();
        }
    };
    CreatePostpaidComponent.prototype.onCashbackTypeChange = function (rule) {
        if (rule.get('cashbackType').value !== 'rides') {
            rule.get('cashbackMinValue').setValue(null);
        }
    };
    CreatePostpaidComponent.prototype.errorMessage = function (message) {
        this.toasterService.showToaster(new Toaster({
            type: ToasterType.WARNING,
            message: message
        }));
    };
    CreatePostpaidComponent.prototype.validateField = function (fieldName, message, group) {
        if (group === void 0) { group = this.postpaidFormGroup; }
        var value = group.get(fieldName).value;
        if (value === null || value === undefined || value === '') {
            this.errorMessage(message);
            throw new Error(message);
        }
        return value;
    };
    CreatePostpaidComponent.prototype.buildValidity = function (rule) {
        var validityType = this.validateField('validityType', 'Validity type is required', rule);
        if (validityType === 'unlimited' && this.isFemaleGender) {
            return [{ type: 'unlimited', maxValue: null }];
        }
        if (validityType === 'unlimited') {
            return [{ type: 'unlimited' }];
        }
        var maxValue = this.validateField('maxValue', 'Max value is required', rule);
        if (Number(maxValue) <= 0) {
            this.errorMessage('Max value must be greater than zero');
            throw new Error('Max value must be greater than zero');
        }
        return [{ type: validityType, maxValue: Number(maxValue) }];
    };
    CreatePostpaidComponent.prototype.buildCashback = function (rule, amount) {
        var cashbackType = rule.get('cashbackType').value || 'none';
        if (cashbackType !== 'rides') {
            return [];
        }
        var minValue = this.validateField('cashbackMinValue', 'Rides min value for cashback is required', rule);
        if (Number(minValue) <= 0) {
            this.errorMessage('Rides min value for cashback must be greater than zero');
            throw new Error('Rides min value for cashback must be greater than zero');
        }
        return [{
                cashbackAmount: amount,
                minValue: Number(minValue),
                type: 'rides'
            }];
    };
    CreatePostpaidComponent.prototype.periodInDaysForRule = function (rule) {
        if (!this.isPaidUnlimited(rule)) {
            return undefined;
        }
        var periodInDays = this.validateField('periodInDays', 'Period in days is required', rule);
        if (Number(periodInDays) <= 0) {
            this.errorMessage('Period in days must be greater than zero');
            throw new Error('Period in days must be greater than zero');
        }
        return Number(periodInDays);
    };
    CreatePostpaidComponent.prototype.buildRule = function (rule) {
        var amount = Number(this.validateField('amount', 'Amount to be deducted is required', rule));
        if (amount < 0) {
            this.errorMessage('Amount to be deducted must be zero or more');
            throw new Error('Amount to be deducted must be zero or more');
        }
        if (this.isPaidTargetValidity(rule) && amount <= 0) {
            this.errorMessage('Amount to be deducted must be greater than zero');
            throw new Error('Amount to be deducted must be greater than zero');
        }
        var periodInDays = this.periodInDaysForRule(rule);
        return tslib_1.__assign({ cashbackValidity: this.buildCashback(rule, amount), ruleAmount: amount }, (periodInDays != null ? { periodInDays: periodInDays } : {}), { validity: this.buildValidity(rule) });
    };
    CreatePostpaidComponent.prototype.confirmMessageForTargetSegment = function () {
        if (this.isCityWideSegment) {
            return 'Creating this plan will deactivate existing active postpaid plans for the same city, mode, and target segment (entire city or female gender). Continue?';
        }
        return 'Create this postpaid plan?';
    };
    CreatePostpaidComponent.prototype.buildTargetSegmentPayload = function () {
        var segment = this.formValue('targetSegment') || 'entireCity';
        var priority = 0;
        var userSelectors = [];
        var userSelectorName = null;
        var gender = null;
        var isAutoAssignedToHH = false;
        var endTime = null;
        if (segment === 'femaleGender') {
            gender = 1;
        }
        else if (segment === 'userSelectors') {
            var selector = this.validateField('userSelector', 'User selector is required');
            priority = Number(this.validateField('priority', 'Priority is required'));
            if (priority <= 0) {
                this.errorMessage('Priority must be greater than zero');
                throw new Error('Priority must be greater than zero');
            }
            endTime = moment(this.validateField('endDate', 'End time is required').getTime()).unix();
            userSelectors = [selector.id];
            userSelectorName = selector.name;
        }
        else if (segment === 'autoAssign') {
            isAutoAssignedToHH = true;
        }
        return { priority: priority, userSelectors: userSelectors, userSelectorName: userSelectorName, gender: gender, isAutoAssignedToHH: isAutoAssignedToHH, endTime: endTime };
    };
    CreatePostpaidComponent.prototype.hasOverlappingPriorityRules = function (segmentPayload, startTime, categoryServices) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var overlapping;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.showUserSelector) {
                            return [2 /*return*/, false];
                        }
                        return [4 /*yield*/, this.subsService.getRules({
                                filters: {
                                    type: 'POSTPAID',
                                    serviceDetails: categoryServices.map(function (service) { return service.serviceDetailId; }),
                                    cities: [this.context.city.id],
                                    mode: this.context.mode.id,
                                    startTime: startTime,
                                    endTime: segmentPayload.endTime,
                                    active: true,
                                    isAutoAssignedToHH: false,
                                    priorities: [segmentPayload.priority]
                                },
                                pagination: { page: 1, pageSize: this.maxRulesAtOnce }
                            }).toPromise()];
                    case 1:
                        overlapping = _a.sent();
                        if (!overlapping || !overlapping.length) {
                            return [2 /*return*/, false];
                        }
                        this.alertService.open({
                            title: 'Overlapping Subscription Rules with same priority',
                            message: 'Please create a Subscription Rule with other priority to proceed',
                            links: overlapping.map(function (rule) { return ({
                                label: rule.ruleName + " (priority " + rule.priority + ")",
                                url: "/subscription/view/" + rule.id
                            }); })
                        });
                        return [2 /*return*/, true];
                }
            });
        });
    };
    CreatePostpaidComponent.prototype.createPostpaidRule = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var confirmed, ruleName_1, startTime_1, categoryServices_1, excludedServices_1, segmentPayload_1, exclusiveOfTax_1, rules, payload, resp, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.alertService.open({
                            title: 'Confirm',
                            message: this.confirmMessageForTargetSegment(),
                            confirmText: 'Yes, Proceed'
                        });
                        return [4 /*yield*/, this.alertService.confirmed().toPromise()];
                    case 1:
                        confirmed = _a.sent();
                        if (!confirmed) {
                            return [2 /*return*/];
                        }
                        this.loader.openLoading();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 5, 6, 7]);
                        if (!this.context) {
                            throw new Error('Select state, city, mode and category first');
                        }
                        ruleName_1 = this.validateField('ruleName', 'Rule name is required');
                        startTime_1 = moment(this.validateField('startDate', 'Start time is required').getTime()).unix();
                        categoryServices_1 = this.context.categoryServices || [];
                        if (!categoryServices_1.length) {
                            this.errorMessage('No services found in this category');
                            throw new Error('No services found in this category');
                        }
                        excludedServices_1 = (this.formValue('excludedServices') || []).map(function (service) { return service.id; });
                        segmentPayload_1 = this.buildTargetSegmentPayload();
                        exclusiveOfTax_1 = !!(this.context && this.context.exclusiveOfTax);
                        rules = this.rules.controls.map(function (rule) { return _this.buildRule(rule); });
                        return [4 /*yield*/, this.hasOverlappingPriorityRules(segmentPayload_1, startTime_1, categoryServices_1)];
                    case 3:
                        if (_a.sent()) {
                            return [2 /*return*/];
                        }
                        payload = {
                            type: 'POSTPAID',
                            rules: rules.map(function (rule) { return (tslib_1.__assign({}, rule, { categoryLevelApplicability: {
                                    categories: [{
                                            allowedServices: [],
                                            excludedServices: excludedServices_1,
                                            id: _this.context.category
                                        }]
                                }, city: _this.context.city.id, excludeIncentiveTypes: [], exclusiveOfTax: exclusiveOfTax_1, isAutoAssignedToHH: segmentPayload_1.isAutoAssignedToHH, isAutoAssignedToMC: false, isDefaultSubscription: _this.isCityWideSegment, gender: segmentPayload_1.gender, isRecommended: false, mode: _this.context.mode.id, priority: segmentPayload_1.priority, rule: [{
                                        operator: '=',
                                        type: 'flat',
                                        value: 0,
                                        variable: 'commission'
                                    }], ruleName: ruleName_1, ruleTitle: _this.formValue('ruleTitle') || undefined, ruleType: _this.postpaidFormGroup.get('ruleType').value || _this.eligibleRuleTypes[0], serviceDetails: categoryServices_1.map(function (service) { return service.serviceDetailId; }), services: categoryServices_1.map(function (service) { return service.id; }), startTime: startTime_1 }, (segmentPayload_1.endTime != null ? { endTime: segmentPayload_1.endTime } : {}), { suspendServicesPostExpiry: false, userSelectors: segmentPayload_1.userSelectors, userSelectorName: segmentPayload_1.userSelectorName || undefined })); })
                        };
                        return [4 /*yield*/, this.subsService.createSubscriptionRules(payload).toPromise()];
                    case 4:
                        resp = _a.sent();
                        this.alertService.open(subscriptionCreateSuccessAlert(resp, { configRequestKind: 'subscription' }));
                        return [3 /*break*/, 7];
                    case 5:
                        error_1 = _a.sent();
                        this.alertService.open(subscriptionOperationFailureAlert(error_1));
                        return [3 /*break*/, 7];
                    case 6:
                        this.loader.closeLoading();
                        return [7 /*endfinally*/];
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    return CreatePostpaidComponent;
}());
export { CreatePostpaidComponent };
